<template>
  <div class="wt2-sg -top-bar-inner">
    <div class="wt-add-text-button -button-container">
      <wt-button
        class="js-disable-to-reset"
        text="Add Text"
        @click="addTextOverlay"
        type="hollow-dark"
        icon="wticon-plus"
      />
    </div>
    <text-overlay-grid-buttons />
  </div>
</template>

<script>
import app from 'app';
import bus from 'v/AssetEditor/AssetEditorEventBus';
import TextOverlayGridButtons from 'AssetEditor/functionality/TextOverlay/TextOverlayGridButtons.vue';
import Analytics from 'c/WtAnalytics';
import { mapGetters, mapMutations, mapState } from 'vuex';

export default {
  computed: {
    ...mapGetters('assetEditor', ['tmpAGD']),
    ...mapState('assetEditor', ['ianToModel', 'story']),

    textOverlays: function () {
      return this.tmpAGD.textOverlays;
    },
  },

  components: {
    TextOverlayGridButtons,
  },

  mounted: function () {
    if (_.isObject(this.ianToModel)) {
      if (!_.isEmpty(this.ianToModel)) {
        this.placeholder = { ...this.ianToModel, placeholder: true };
        this.addTextOverlay(null, { ...this.placeholder }, false);
      }
      this.resetInAssetNavigationTOModel();
    } else if (_.isEmpty(this.textOverlays)) {
      this.addTextOverlay();
    }
    bus.$on('paste', this.onPaste);
  },

  beforeDestroy: function () {
    bus.$off('paste', this.onPaste);
  },

  methods: {
    ...mapMutations('assetEditor', [
      'setTmpPageState',
      'resetInAssetNavigationTOModel',
      'addTempTextOverlay',
    ]),

    trackTextOverlay: function (e, obj) {
      Analytics.trigger('analytics:textOverlay:' + e, obj);
    },

    compareTOS(to1, to2) {
      function pickTo(to) {
        const regex = RegExp(
          /^(animationPresets|height|padding|paragraphs|placeholder|overlay_id|animationOutId|animationInId|zIndex|id|_text|html|dirty|mode)$/
        );
        return _.pickBy(
          to,
          (value, key) =>
            !_.isUndefined(value) && !_.isNull(value) && !regex.test(key)
        );
      }
      return _.isEqual(pickTo(to1), pickTo(to2));
    },

    addTextOverlay: function (e, exampleTOModel, keepStartEndTimes = false) {
      const id = 'TO_' + app.guid();
      let x = 100;
      let y = 100;

      if (!_.isEmpty(exampleTOModel)) {
        x = exampleTOModel.offsetX * app.ASSET_EDITOR_WIDTH;
        y = exampleTOModel.offsetY * app.ASSET_EDITOR_HEIGHT;
      }

      // We'll check to see if there are already TO rendered. If so, we'll make sure not to exaclty overlap
      // one of them, by shifting it a little.
      let collisionTO = true;
      while (collisionTO) {
        collisionTO = this.checkIfOverlayExistsOnXY(x, y);
        if (collisionTO) {
          const toHeight = collisionTO.offsetY + collisionTO.height;
          x =
            (collisionTO.offsetX + collisionTO.width / 4) *
              app.ASSET_EDITOR_WIDTH +
            0.1;
          y = toHeight * app.ASSET_EDITOR_HEIGHT + 0.1;
        }
      }

      const offsetX = app.sfp(x / app.ASSET_EDITOR_WIDTH);
      const offsetY = app.sfp(y / app.ASSET_EDITOR_HEIGHT);

      bus.$emit('to:reset');
      const zIndex = 0;
      if (!_.isEmpty(this.textOverlays)) {
        for (const to of this.textOverlays) {
          to.zIndex = to.zIndex + 1;
        }
      }
      let textOverlay;

      if (!_.isEmpty(exampleTOModel)) {
        textOverlay = Object.assign(_.cloneDeep(exampleTOModel), {
          id,
          zIndex,
          offsetX,
          offsetY,
        });
        if (!keepStartEndTimes) {
          Object.assign(exampleTOModel, {
            animationStartTime: 0,
            animationEndTime: 1,
          });
        }
      } else {
        textOverlay = {
          id,
          offsetX,
          offsetY,
          width: app.sfp(300 / app.ASSET_EDITOR_WIDTH),
          height: app.sfp(20 / app.ASSET_EDITOR_HEIGHT),
          zIndex: 0,
          bgColor: 'transparent',
          bgGradient: null,
          textShadow: 'none',
          lineHeight: '1.03',
          fontSize: '50',
          rotation: 0,
          presetType: 'GENERAL',
          html: '',
          padding: '0',
          protocol: app.TEXT_OVERLAY_VERSION,
          canvasWidth: app.ASSET_EDITOR_WIDTH,
          canvasHeight: app.ASSET_EDITOR_HEIGHT,
          animationStartTime: 0,
          animationEndTime: 1,
          animationId: app.ANIMATION.NONE.id,
          animationOutId: app.ANIMATION.NONE.continueId,
        };
      }

      if (this.checkIfOverlayOutOfStage(textOverlay)) {
        textOverlay.offsetX = 0;
        textOverlay.offsetY = 0;
      }

      // this.video && this.video.pause();
      this.$nextTick(() => {
        this.$root.$emit('pause-video');
        this.addTempTextOverlay(textOverlay);
        bus.$emit('to:added', textOverlay);
        this.trackTextOverlay('add');
      });
    },

    checkIfOverlayExistsOnXY: function (x, y) {
      return _.find(this.textOverlays, function (textOverlay) {
        const x1 = app.sfp(x / app.ASSET_EDITOR_WIDTH);
        const y1 = app.sfp(y / app.ASSET_EDITOR_HEIGHT);

        const toHeight = textOverlay.offsetY + textOverlay.height;
        const toWidth = textOverlay.offsetX + textOverlay.width;

        return (
          x1 >= textOverlay.offsetX &&
          x1 <= toWidth &&
          y1 >= textOverlay.offsetY &&
          y1 <= toHeight
        );
      });
    },

    checkIfOverlayOutOfStage(textOverlay) {
      const canvasWidth = app.ASSET_EDITOR_WIDTH;
      const canvasHeight = app.ASSET_EDITOR_HEIGHT;
      // const width = textOverlay.width * canvasWidth;
      // const height =  textOverlay.height * canvasHeight;
      const x = textOverlay.offsetX * canvasWidth;
      const y = textOverlay.offsetY * canvasHeight;

      const xOut = x > canvasWidth;
      const yOut = y > canvasHeight;

      return xOut || yOut;
    },

    onPaste: function (e) {
      if (!_.isEmpty(e.clipboardData.getData('application/toCopy'))) {
        const to = JSON.parse(e.clipboardData.getData('application/toCopy'));
        if (to) {
          Analytics.trigger('analytics:textOverlay:pasteText', {
            videoID: _.isObject(this.story) && this.story.id,
          });
          const placeholder = this.textOverlays.find((to) => to.placeholder);
          if (
            !_.isEmpty(this.placeholder) &&
            !_.isEmpty(placeholder) &&
            this.compareTOS(this.placeholder, placeholder)
          ) {
            this.textOverlays.splice(
              this.textOverlays.findIndex((t) => t.placeholder),
              1
            );
          }
          this.addTextOverlay(null, to, true);
          e.preventDefault();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.-top-bar-inner {
  padding-bottom: 30px;
  position: relative;
}

.-button-container {
  font-size: 0;
  button {
    margin-right: 20px;
    &:last-child {
      margin-right: 0;
    }
  }
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  bottom: 30px;
  z-index: 1;
}
</style>
